import { render, staticRenderFns } from "./InvoiceModule.vue?vue&type=template&id=529a7aca&scoped=true&"
import script from "./InvoiceModule.vue?vue&type=script&lang=js&"
export * from "./InvoiceModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a7aca",
  null
  
)

export default component.exports